import { render, staticRenderFns } from "./CmsMenuGroup.vue?vue&type=template&id=46a61e93&"
import script from "./CmsMenuGroup.vue?vue&type=script&lang=js&"
export * from "./CmsMenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports